import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

// API  status fetch  async thunk
export const fetchPropertyStatuses = createAsyncThunk(
  "propertyStatuses/fetch",
  async () => {
    const res = await api.get("/api/property-statuses");

    return res.data;
  }
);

const propertyStatusSlice = createSlice({
  name: "propertyStatuses",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertyStatuses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPropertyStatuses.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchPropertyStatuses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default propertyStatusSlice.reducer;
